"use client"

import TablaRrhhLiquidacionesComponent from "./TablaRrhhLiquidacionesComponent.js"

const RrhhLiquidacionesComponent = () => {
  return <TablaRrhhLiquidacionesComponent />
}

export default RrhhLiquidacionesComponent
